import { render, staticRenderFns } from "./ProjectWrapper.vue?vue&type=template&id=74452038"
import script from "./ProjectWrapper.vue?vue&type=script&lang=js"
export * from "./ProjectWrapper.vue?vue&type=script&lang=js"
import style0 from "./ProjectWrapper.vue?vue&type=style&index=0&id=74452038&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports